import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { createShigoQueryClient } from './shigoQueryClient';

const queryClient = createShigoQueryClient();

export function ShigoQueryProvider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
